export { default } from './CategoryLink';
